import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import loadingShutters from '../assets/loadingShutters.png';
import { getLoadingText } from '../utils/streamableHelpers';
import styles from '../styles/PageWrapper.scss';

export const LoadingComponent = ({ loadingStep, hasMessages }) => {
  const intl = useIntl();

  return (
    <div
      style={{ margin: '0 auto', padding: '0 3rem' }}
      className={`${hasMessages ? styles.loadingMargin : ''} flex flex-item-grow 
      flex-column flex-justify-center flex-align-center`}
    >
      <div
        className="
        heading-sans-xsmall-bold text-align-center width-full
        position-relative flex flex-justify-center
        flex-align-center
        "
        style={{
          height: '3.2em',
          overflow: 'hidden',
        }}
      >
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={loadingStep}
            initial={{ y: '100%' }}
            animate={{ y: '0%' }}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.4, ease: 'easeInOut' }}
            style={{
              position: 'absolute',
              width: '100%',
              left: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div
              style={{ maxWidth: '100%' }}
              className={styles.loadingText}
            >
              {getLoadingText(intl, loadingStep)}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      <img
        src={loadingShutters}
        alt="Decorative stars"
        aria-hidden="true"
        style={{ width: '100%' }}
      />
    </div>
  );
};

LoadingComponent.propTypes = {
  loadingStep: PropTypes.string.isRequired,
  hasMessages: PropTypes.bool.isRequired,
};
